import React, { useCallback, useState } from "react";
import CustomBackdrop from "components/common/backdrop/CustomBackdrop";

export const useBackdrop = () => {
  const [display, setDisplay] = useState(false);
  const [backdropMessage, setBackdropMessage] = useState("");

  const showBackdrop = useCallback(() => setDisplay(true), []);
  const hideBackdrop = useCallback(() => setDisplay(false), []);
  const Backdrop = useCallback(
    () => <>{display && <CustomBackdrop message={backdropMessage} />}</>,
    [display, backdropMessage]
  );

  return { Backdrop, showBackdrop, hideBackdrop, setBackdropMessage };
};
